import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '../../components/ProtectedRoute';
import { lazyWithRetry } from '../../lib/lazyWithRetry';

const InsuranceDashboard = lazyWithRetry(() => import('../../pages/Insurance/Dashboard/InsuranceDashboard'));
const VendorCoverageList = lazyWithRetry(() => import('../../pages/Insurance/VendorCoverage/VendorCoverageList'));
const VendorCoverageDetail = lazyWithRetry(() => import('../../pages/Insurance/VendorCoverage/VendorCoverageDetail'));
const CustomerCertificatesList = lazyWithRetry(() => import('../../pages/Insurance/CustomerCertificates/CustomerCertificatesList'));
const CustomerCertificateDetail = lazyWithRetry(() => import('../../pages/Insurance/CustomerCertificates/CustomerCertificateDetail'));
const PoliciesList = lazyWithRetry(() => import('../../pages/Insurance/Policies/PoliciesList'));
const PolicyDetail = lazyWithRetry(() => import('../../pages/Insurance/Policies/PolicyDetail'));
const ClaimsList = lazyWithRetry(() => import('../../pages/Insurance/Claims/ClaimsList'));
const ClaimDetail = lazyWithRetry(() => import('../../pages/Insurance/Claims/ClaimDetail'));
const PortalsList = lazyWithRetry(() => import('../../pages/Insurance/Portals/PortalsList'));
const PortalDetail = lazyWithRetry(() => import('../../pages/Insurance/Portals/PortalDetail'));
const DavidActivityPage = lazyWithRetry(() => import('../../pages/Insurance/Activity/DavidActivityPage'));

export const routes: RouteObject[] = [
  { index: true, element: <ProtectedRoute><InsuranceDashboard /></ProtectedRoute> },
  { path: 'vendors', element: <ProtectedRoute><VendorCoverageList /></ProtectedRoute> },
  { path: 'vendors/:vendorName', element: <ProtectedRoute><VendorCoverageDetail /></ProtectedRoute> },
  { path: 'customers', element: <ProtectedRoute><CustomerCertificatesList /></ProtectedRoute> },
  { path: 'customers/:requestId', element: <ProtectedRoute><CustomerCertificateDetail /></ProtectedRoute> },
  { path: 'policies', element: <ProtectedRoute><PoliciesList /></ProtectedRoute> },
  { path: 'policies/:policyId', element: <ProtectedRoute><PolicyDetail /></ProtectedRoute> },
  { path: 'claims', element: <ProtectedRoute><ClaimsList /></ProtectedRoute> },
  { path: 'claims/:claimId', element: <ProtectedRoute><ClaimDetail /></ProtectedRoute> },
  { path: 'portals', element: <ProtectedRoute><PortalsList /></ProtectedRoute> },
  { path: 'portals/:portalId', element: <ProtectedRoute><PortalDetail /></ProtectedRoute> },
  { path: 'activity', element: <ProtectedRoute requireManagerOrAdmin><DavidActivityPage /></ProtectedRoute> },
];
